import React from 'react';
import './content-sub-page-menu.css'
import pic45 from '../../assets/pic45.png'
import pic46 from '../../assets/pic46.png'
import pic47 from '../../assets/pic47.png'
import pic48 from '../../assets/pic48.png'
import pic49 from '../../assets/pic49.png'
import pic50 from '../../assets/pic50.png'
import pic51 from '../../assets/pic51.png'
import { Link, useLocation } from 'react-router-dom';

const Contentsubpagemenu = () => {
    const location = useLocation();

    return ( 

        <section className='containerr-content-navss'>
            <Link to="/content-management-navigations" className='link-contentt'>
                            <button
                                className={
                                    location.pathname === '/content-management-navigations'
                                    ? 'active-content-cta'
                                    : 'nonactive-content-cta'
                                }
                            >
                                <img
                                        src={pic45}
                                        alt='popups'
                                        className={
                                            location.pathname === '/content-management-navigations'
                                            ? 'active-content-icon'
                                            : 'nonactive-content-icon'
                                        }
                                    />

                                <h2
                                    className={
                                        location.pathname === '/content-management-navigations'
                                        ? 'active-content-cta-text'
                                        : 'nonactive-content-cta-text'
                                    }
                                >
                                    Navigation
                                </h2>
                            </button>
              </Link>



                <Link to="/content-management-popups" className='link-contentt'>
                <button
                    className={
                        location.pathname === '/content-management-popups'
                        ? 'active-content-cta'
                        : 'nonactive-content-cta'
                    }
                >
                 <img
                                        src={pic46}
                                        alt='popups'
                                        className={
                                            location.pathname === '/content-management-popups'
                                            ? 'active-content-icon'
                                            : 'nonactive-content-icon'
                                        }
                                    />

                    <h2
                        className={
                            location.pathname === '/content-management-popups'
                            ? 'active-content-cta-text'
                            : 'nonactive-content-cta-text'
                        }
                    >
                        Popups
                    </h2>
                </button>
            </Link>



                <Link to="/content-management-home" className='link-contentt'>
                <button
                    className={
                        location.pathname === '/content-management-home'
                        ? 'active-content-cta'
                        : 'nonactive-content-cta'
                    }
                >
                    <img  src={pic47} 
                                        alt='home'
                                        className={
                                            location.pathname === '/content-management-home'
                                            ? 'active-content-icon'
                                            : 'nonactive-content-icon'
                                        }
                                    />

                    <h2
                        className={
                            location.pathname === '/content-management-home'
                            ? 'active-content-cta-text'
                            : 'nonactive-content-cta-text'
                        }
                    >
                        Home Page
                    </h2>
                </button>
            </Link>




                <Link to="/content-management-Exhibitors" className='link-contentt'>
                <button
                    className={
                        location.pathname === '/content-management-Exhibitors'
                        ? 'active-content-cta'
                        : 'nonactive-content-cta'
                    }
                >
                    <img  src={pic48} 
                                                            alt='Exhibitors'
                                        className={
                                            location.pathname === '/content-management-Exhibitors'
                                            ? 'active-content-icon'
                                            : 'nonactive-content-icon'
                                        }
                                    />


                    <h2
                        className={
                            location.pathname === '/content-management-Exhibitors'
                            ? 'active-content-cta-text'
                            : 'nonactive-content-cta-text'
                        }
                    >
                        Exhibitors Page
                    </h2>
                </button>
            </Link>




                <Link to="" className='link-contentt'>
                <button
                    className={
                        location.pathname === ''
                        ? 'active-content-cta'
                        : 'nonactive-content-cta'
                    }
                >
                    <img  src={pic49}
                                                   alt='Booking'
                                        className={
                                            location.pathname === ''
                                            ? 'active-content-icon'
                                            : 'nonactive-content-icon'
                                        }
                                    />

                    <h2
                        className={
                            location.pathname === ''
                            ? 'active-content-cta-text'
                            : 'nonactive-content-cta-text'
                        }
                    >
                        Booking Page
                    </h2>
                </button>
            </Link>




                <Link to="" className='link-contentt'>
                <button
                    className={
                        location.pathname === ''
                        ? 'active-content-cta'
                        : 'nonactive-content-cta'
                    }
                >
                    <img  src={pic50} 
                                  alt='Gallery'
                                        className={
                                            location.pathname === ''
                                            ? 'active-content-icon'
                                            : 'nonactive-content-icon'
                                        }
                                    />

                    <h2
                        className={
                            location.pathname === ''
                            ? 'active-content-cta-text'
                            : 'nonactive-content-cta-text'
                        }
                    >
                        Gallery Page
                    </h2>
                </button>
            </Link>



                <Link to="" className='link-contentt'>
                <button
                    className={
                        location.pathname === ''
                        ? 'active-content-cta'
                        : 'nonactive-content-cta'
                    }
                >
                    <img  src={pic51}
                                                alt='About'
                                        className={
                                            location.pathname === ''
                                            ? 'active-content-icon'
                                            : 'nonactive-content-icon'
                                        }
                                    />

                    <h2
                        className={
                            location.pathname === ''
                            ? 'active-content-cta-text'
                            : 'nonactive-content-cta-text'
                        }
                    >
                        About Page
                    </h2>
                </button>
            </Link>





        </section>
     );
}
 
export default Contentsubpagemenu;